import { Box, Card, styled } from '@mui/material';

export const CardStyled = styled(Card)(({ theme }) => ({
  width: '100%',
  color: 'white',
  background: theme.palette.primary.main,
  border: `1px solid ${theme.palette.secondary.dark}`,
  padding: '1.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: '1.5rem',
}));

export const CardContentStyled = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  height: '3.25rem',
  padding: 0,
  gap: '7rem',

  [theme.breakpoints.down('sm')]: {
    gap: '1rem',
    flexDirection: 'column',
    height: 'auto',
  },
}));
